
<template>
  <div class="form__group">
    <date-picker :date="startDate" :option="option" :showActionButtons="showbtn"   ></date-picker>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker/DatePicker'
import EventBus from '../../eventBus'

export default {
  name: 'dateField',
  props: {
    label: {
      required: false,
      type: String
    },
    value: {
      required: true
    },
    name: {
      required: true,
      type: String
    },
    errorMessage: {
      required: false,
      type: String
    },
    hasError: {
      required: false
    },
    required: {
      type: Boolean
    },
    isRepeatField:{
      type: Boolean
    }
  },
  mounted () {
    //console.log("this.value--",this.value)
    // EventBus.$on('date',()=>{
    //   console.log('bus is working')
    //   this.startDate = {
    //   time:'' 
    //   }
    // })
    this.startDate = {time: this.value ? this.value : '' }
    this.updateInput()
  },
  data: () => ({
    startDate: {
      time: ''
    },
    option: {
      type: 'day',
      week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      format: `YYYY-MM-DD`,
      inputClass: 'form-control',
      color: {
        checked: '#F50057',
        header: '#423799',
        headerText: '#fff'
      },
      buttons: {
        ok: 'Ok',
        cancel: 'Cancel'
      },
      overlayOpacity: 0.5, // 0.5 as default
      dismissible: true // as true as default
    },
    showbtn:false
  }),
  methods: {
    updateInput () {
      var value =  this.startDate.time 
      this.$emit('input', value)
    },
    // onSaved(){
    //   console.log("outttt--")
    // }
  },
  watch: {
    'startDate.time' () {
      this.updateInput()
      return this.startDate.time
    },
    'value'(){
      this.startDate.time= this.value
      //console.log("watch val---",this.value)
      // console.log("this.startDate---",this.startDate.time)
      
    }
  },
  components: {
    DatePicker
  }
}
</script>





<!--<template>
   <div class="form__group" :class="{ 'has-danger' : hasError }">
    <label :for="name" v-if="label">{{ label }}: <span class="required" v-if="required">*</span></label>
    <input type="text" v-model="input" :id="name" :name="name" @keyup="keyUpHandle" :required="required" class="form-control" :class="{'is-danger': hasError }" autocomplete="off" maxlength="10">
    <span class="help is-danger" v-if="hasError">{{ errorMessage }}</span>
  </div> 
</template>-->

<!--<script>
// import VMasker from 'vanilla-masker'

// export default {
//   name: 'dateField',
//   props: {
//     label: {
//       required: false,
//       type: String
//     },
//     value: {
//       required: true
//     },
//     name: {
//       required: true,
//       type: String
//     },
//     errorMessage: {
//       required: false,
//       type: String
//     },
//     hasError: {
//       required: false
//     },
//     required: {
//       type: Boolean
//     }
//   },
//   mounted () {
//     this.input = this.applyMask(this.value)
//     this.updateInput()
//   },
//   data: () => ({
//     input: ''
//   }),
//   methods: {
//     keyUpHandle () {
//       this.input = this.applyMask(this.input)
//       this.updateInput()
//     },
//     updateInput () {
//       this.$emit('input', this.input)
//     },
//     applyMask (value) {
//       return VMasker.toPattern(value, '99/99/9999')
//     }
//   }
// }
// </script>



// WEBPACK FOOTER //
// DateField.vue?3e013ab4